var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0.68934 1.06434C0.970644 0.783036 1.35217 0.625 1.75 0.625H12.25C12.6478 0.625 13.0294 0.783035 13.3107 1.06434C13.592 1.34565 13.75 1.72718 13.75 2.125V18.625C13.75 18.8976 13.602 19.1488 13.3636 19.281C13.1251 19.4131 12.8337 19.4055 12.6025 19.261L6.99935 15.7594L1.39753 19.261C1.16633 19.4055 0.874916 19.4132 0.636441 19.281C0.397965 19.1488 0.25 18.8977 0.25 18.625V2.125C0.25 1.72717 0.408036 1.34564 0.68934 1.06434ZM12.25 2.125H1.75L1.75 17.2717L6.60177 14.239C6.84497 14.087 7.15356 14.087 7.39677 14.239L12.25 17.2719V2.125Z"
});

function SvgBookmark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmark);
export default __webpack_public_path__ + "static/media/bookmark.d06352e94fba2cd6916380dd63d50c68.svg";
export { ForwardRef as ReactComponent };